'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { Index, Configure, useInstantSearch } from 'react-instantsearch';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import CustomerPhotos from '../../pages/CustomerPhotos';
import CustomerReviews from '../../pages/CustomerReviews';
import StaticPages from '../../pages/StaticPages';
const SectionResultsCountTracker = t0 => {
  const $ = _c(6);
  const {
    onCountChange
  } = t0;
  const {
    results
  } = useInstantSearch();
  let t1;
  if ($[0] !== onCountChange || $[1] !== results?.nbHits) {
    t1 = () => {
      const count = results?.nbHits;
      if (Number.isFinite(count)) {
        onCountChange(count);
      }
    };
    $[0] = onCountChange;
    $[1] = results?.nbHits;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = results?.nbHits;
  let t3;
  if ($[3] !== onCountChange || $[4] !== t2) {
    t3 = [t2, onCountChange];
    $[3] = onCountChange;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t1, t3);
  return null;
};
const REVIEW_ATTRIBUTES = ['review_id', 'review_full_name', 'review_rate', 'review_comment', 'review_title', 'review_date', 'product_name', 'product_url', 'sef_url', 'image_link', 'fk_product_id'];
const STATIC_PAGES_NUMERIC_FILTERS = ['is_active=1', 'show_in_search=1', 'fk_store_id=1'];

/**
 * Shared secondary indexes for sidebar counts + active-section results.
 * Inactive sections use hitsPerPage=0 (nbHits only).
 */
const AdvancedSearchSecondaryIndexes = t0 => {
  const $ = _c(29);
  const {
    getCustomProps,
    onCountChange
  } = t0;
  const {
    currentSearchSection
  } = useAdvancedSearchContext();
  const isPhotosActive = currentSearchSection === ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS;
  const isReviewsActive = currentSearchSection === ALGOLIA_INDEX_NAME.REVIEWS;
  const isPagesActive = currentSearchSection === ALGOLIA_INDEX_NAME.STATIC_PAGES;
  let t1;
  if ($[0] !== isPhotosActive) {
    t1 = isPhotosActive ? <Configure facets={["*"]} filters="" numericFilters="" facetFilters={[]} attributesToRetrieve={["*"]} /> : <Configure filters="" numericFilters="" facetFilters={[]} hitsPerPage={0} />;
    $[0] = isPhotosActive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getCustomProps || $[3] !== isPhotosActive || $[4] !== onCountChange) {
    t2 = isPhotosActive && <><SectionResultsCountTracker onCountChange={onCountChange} /><CustomerPhotos getCustomProps={getCustomProps} /></>;
    $[2] = getCustomProps;
    $[3] = isPhotosActive;
    $[4] = onCountChange;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <Index indexName={ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS}>{t1}{t2}</Index>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isReviewsActive) {
    t4 = isReviewsActive ? <Configure facets={["*"]} filters="" numericFilters="" facetFilters={[]} attributesToRetrieve={REVIEW_ATTRIBUTES} /> : <Configure filters="" numericFilters="" facetFilters={[]} hitsPerPage={0} />;
    $[9] = isReviewsActive;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isReviewsActive || $[12] !== onCountChange) {
    t5 = isReviewsActive && <><SectionResultsCountTracker onCountChange={onCountChange} /><CustomerReviews /></>;
    $[11] = isReviewsActive;
    $[12] = onCountChange;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <Index indexName={ALGOLIA_INDEX_NAME.REVIEWS}>{t4}{t5}</Index>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isPagesActive) {
    t7 = isPagesActive ? <Configure filters="" numericFilters={STATIC_PAGES_NUMERIC_FILTERS} attributesToRetrieve={["*"]} /> : <Configure filters="" numericFilters={STATIC_PAGES_NUMERIC_FILTERS} hitsPerPage={0} />;
    $[17] = isPagesActive;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== isPagesActive || $[20] !== onCountChange) {
    t8 = isPagesActive && <><SectionResultsCountTracker onCountChange={onCountChange} /><StaticPages /></>;
    $[19] = isPagesActive;
    $[20] = onCountChange;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}>{t7}{t8}</Index>;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t3 || $[26] !== t6 || $[27] !== t9) {
    t10 = <>{t3}{t6}{t9}</>;
    $[25] = t3;
    $[26] = t6;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
export default AdvancedSearchSecondaryIndexes;